import { openDB } from "idb"
import { SYSConfig } from "./config"
// make stores use _001_ instead of appid
// changes to schema should be handled with a different version
export const _GetSYSStateStoreName = () => `ovl_001_state`
export const _GetSYSFilterSortStoreName = () => {
  return `ovl_001_filtersortstate`
}

export const _GetSYSSessionStoreName = () => {
  return `ovl_001_session`
}

export const _GetSYSTableSettingsStoreName = () => {
  return `ovl_001_tablesettings`
}

const dbPromiseSYS = openDB("ovl", 6, {
  upgrade(db) {
    try {
      db.createObjectStore(_GetSYSSessionStoreName())
    } catch {}
    try {
      db.createObjectStore(_GetSYSStateStoreName())
    } catch {}
    try {
      db.createObjectStore(_GetSYSFilterSortStoreName())
    } catch {}
    try {
      db.createObjectStore(_GetSYSTableSettingsStoreName())
    } catch {}
  },
})

//usecase: save and rehydrate full app
export const stateStore = {
  async get(key: string) {
    return (await dbPromiseSYS).get(_GetSYSStateStoreName(), key)
  },
  async set(key: string, val) {
    return (await dbPromiseSYS).put(_GetSYSStateStoreName(), val, key)
  },
  async clear() {
    return (await dbPromiseSYS).clear(_GetSYSStateStoreName())
  },
}

//usecase: persist filter sort settings
export const filterSortStore = {
  async get(key: string) {
    return (await dbPromiseSYS).get(_GetSYSFilterSortStoreName(), key)
  },

  async getAllKeys(filter: string) {
    return (await dbPromiseSYS).getAllKeys(_GetSYSFilterSortStoreName(), filter)
  },

  async set(key: string, val) {
    return (await dbPromiseSYS).put(
      _GetSYSFilterSortStoreName(),
      JSON.parse(JSON.stringify(val)),
      key
    )
  },
  async clear() {
    return (await dbPromiseSYS).clear(_GetSYSFilterSortStoreName())
  },
}

//usecase: persist table layout and general rendering settings
export const tableSettingsStore = {
  async get(key: string) {
    return (await dbPromiseSYS).get(_GetSYSTableSettingsStoreName(), key)
  },

  async getAllKeys(filter: string) {
    return (await dbPromiseSYS).getAllKeys(
      _GetSYSTableSettingsStoreName(),
      filter
    )
  },

  async set(key: string, val) {
    return (await dbPromiseSYS).put(
      _GetSYSTableSettingsStoreName(),
      JSON.parse(JSON.stringify(val)),
      key
    )
  },
  async clear() {
    return (await dbPromiseSYS).clear(_GetSYSTableSettingsStoreName())
  },
}

//usecase: session inf (language, token, selected Company, ...)
export const sessionStore = {
  async get(key: string) {
    return (await dbPromiseSYS).get(_GetSYSSessionStoreName(), key)
  },

  async getAllKeys(filter: string) {
    return (await dbPromiseSYS).getAllKeys(_GetSYSSessionStoreName(), filter)
  },

  async set(key: string, val) {
    return (await dbPromiseSYS).put(_GetSYSSessionStoreName(), val, key)
  },
  async clear() {
    return (await dbPromiseSYS).clear(_GetSYSSessionStoreName())
  },
}
